module.exports = __webpack_public_path__ + "img/class_pile.82076afe.png";